export default "__VITE_ASSET__Dps_j_Jb__"